import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import ResultInt from '../../_interface/result-int';
import NebulaModuleBase from './module-base';
export var UpBle = function (_NebulaModuleBase) {
    _inherits(UpBle, _NebulaModuleBase);

    function UpBle() {
        _classCallCheck(this, UpBle);

        var _this = _possibleConstructorReturn(this, (UpBle.__proto__ || Object.getPrototypeOf(UpBle)).apply(this, arguments));

        _this.notifyListenersMap = new Map();
        _this.deviceListeners = new Set();
        _this.bleStatusChangedListeners = new Map();
        // notify监听事件分发
        _this.onContainerNotifyEvent = function (event) {
            var eventListeners = _this.notifyListenersMap.get(event.type);
            window.console.info('onContainerNotifyEvent name ' + event.type, event);
            var data = event === null || event === void 0 ? void 0 : event.data;
            if (eventListeners) {
                window.console.info('onContainerNotifyEvent eventListenersMap name ' + event.type + ', size= ' + eventListeners.size);
            } else {
                window.console.info('onContainerNotifyEvent eventListenersMap name ' + event.type + ', size =0');
            }
            eventListeners === null || eventListeners === void 0 ? void 0 : eventListeners.forEach(function (listener) {
                window.console.info('onContainerNotifyEvent eventListeners callback', data);
                try {
                    listener(data);
                } catch (error) {
                    window.console.info('onContainerNotifyEvent ' + event.type + ' error', error);
                }
            });
        };
        // 蓝牙状态监听事件分发
        _this.onContainerBleStateEvent = function (event) {
            var _a, _b, _c;
            window.console.info('onContainerBleStateEvent name ' + event.type, event === null || event === void 0 ? void 0 : event.data);
            // 解析获取数据
            var status = (_b = (_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'unavailable';
            if (_this.bleStatusChangedListeners) {
                window.console.info('onContainerBleStateEvent eventListenersMap name ' + event.type + ', size=\n                ' + _this.bleStatusChangedListeners.size);
            } else {
                window.console.info('onContainerBleStateEvent eventListenersMap name ' + event.type + ', size =0');
            }
            (_c = _this.bleStatusChangedListeners) === null || _c === void 0 ? void 0 : _c.forEach(function (listener) {
                window.console.info('onContainerBleStateEvent eventListeners callback', status);
                try {
                    listener(status);
                } catch (error) {
                    window.console.info('onContainerBleStateEvent ' + event.type + ' error', error);
                }
            });
        };
        // 蓝牙设备列表变化监听事件分发
        _this.onContainerBleListChangeEvent = function (event) {
            var _a, _b;
            window.console.info('onContainerBleListChangeEvent name ' + event.type, event === null || event === void 0 ? void 0 : event.data);
            // 解析获取数据
            var data = (_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.peripherals;
            if (_this.deviceListeners) {
                window.console.info('onContainerBleListChangeEvent eventListenersMap name ' + event.type + ',\n                size= ' + _this.deviceListeners.size);
            } else {
                window.console.info('onContainerBleListChangeEvent eventListenersMap name\n            ' + event.type + ', size =0');
            }
            (_b = _this.deviceListeners) === null || _b === void 0 ? void 0 : _b.forEach(function (listener) {
                window.console.info('onContainerBleListChangeEvent eventListeners callback', data);
                try {
                    listener(data);
                } catch (error) {
                    window.console.info('onContainerBleListChangeEvent ' + event.type + ' error', error);
                }
            });
        };
        return _this;
    }

    _createClass(UpBle, [{
        key: 'initManager',
        value: function initManager(params) {
            return this.generatePromiseByFunctionWithParams('initManagerAction', params);
        }
    }, {
        key: 'scan',
        value: function scan(params) {
            return this.generatePromiseByFunctionWithParams('scanBleAction', params);
        }
    }, {
        key: 'isScanning',
        value: function isScanning() {
            return this.generatePromiseByFunctionWithParams('isScanningAction', null);
        }
    }, {
        key: 'connect',
        value: function connect(params) {
            return this.generatePromiseByFunctionWithParams('connectAction', params);
        }
    }, {
        key: 'disconnect',
        value: function disconnect(params) {
            return this.generatePromiseByFunctionWithParams('disconnectAction', params);
        }
    }, {
        key: 'isConnected',
        value: function isConnected(params) {
            return this.generatePromiseByFunctionWithParams('isConnectedAction', params);
        }
    }, {
        key: 'getPeripherals',
        value: function getPeripherals() {
            return this.generatePromiseByFunctionWithParams('getPeripheralAction', null);
        }
    }, {
        key: 'getPeripheralServicesByUuid',
        value: function getPeripheralServicesByUuid(params) {
            return this.generatePromiseByFunctionWithParams('discoverServiceAction', params);
        }
    }, {
        key: 'getPeripheralCharacteristicsByUuids',
        value: function getPeripheralCharacteristicsByUuids(params) {
            return this.generatePromiseByFunctionWithParams('discoverCharacteristicsAction', params);
        }
    }, {
        key: 'setPeripheralValueByUuids',
        value: function setPeripheralValueByUuids(params) {
            return this.generatePromiseByFunctionWithParams('writeValueForCharacteristicAction', params);
        }
    }, {
        key: 'getCharacteristicsValue',
        value: function getCharacteristicsValue(params) {
            return this.generatePromiseByFunctionWithParams('getCharacteristicsValueAction', params);
        }
    }, {
        key: 'setNotify',
        value: function setNotify(params) {
            var event = 'BleValueChange_' + params.peripheralUUID + params.serviceUUID + params.characteristicUUID;
            var params1 = {
                eventName: event,
                peripheralUUID: params.peripheralUUID,
                serviceUUID: params.serviceUUID,
                characteristicUUID: params.characteristicUUID
            };
            return this.attachListenerWithParams(event, params.notifyCallback, 'setNotifyAction', params1);
        }
    }, {
        key: 'stopNotify',
        value: function stopNotify() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.notifyListenersMap.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var eventName = _step.value;

                    window.console.info('stopNotify removeEventListener ' + eventName);
                    document.removeEventListener(eventName, this.onContainerNotifyEvent, false);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator['return']) {
                        _iterator['return']();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.notifyListenersMap.clear();
            return this.generatePromiseByFunctionWithParams('stopNotifyAction', null);
        }
    }, {
        key: 'stopScan',
        value: function stopScan() {
            return this.generatePromiseByFunctionWithParams('stopScanAction', null);
        }
    }, {
        key: 'clean',
        value: function clean() {
            return this.generatePromiseByFunctionWithParams('cleanAction', null);
        }
    }, {
        key: 'addStateListener',
        value: function addStateListener(bleStatus, key) {
            var event = 'BleStatusChange';
            var params = {
                eventName: event,
                key: key
            };
            if (!this.bleStatusChangedListeners || this.bleStatusChangedListeners.size === 0) {
                document.addEventListener(event, this.onContainerBleStateEvent, false);
            }
            this.bleStatusChangedListeners.set(key, bleStatus);
            return this.generatePromiseByFunctionWithParams('attachBleStatusListenerAction', params);
        }
    }, {
        key: 'removeStateListener',
        value: function removeStateListener(key) {
            var event = 'BleStatusChange';
            var params = {
                eventName: event,
                key: key
            };
            var deleteResult = this.bleStatusChangedListeners['delete'](key);
            window.console.info('Detach ' + event + ' ,result=' + deleteResult + ', size= ' + this.bleStatusChangedListeners.size);
            if (!deleteResult) {
                return Promise.reject(new ResultInt('000001', '\u76D1\u542C\u56DE\u8C03\u4E0D\u5B58\u5728'));
            } else {
                if (!this.bleStatusChangedListeners || this.bleStatusChangedListeners.size === 0) {
                    document.removeEventListener(event, this.onContainerBleStateEvent, false);
                }
                return this.generatePromiseByFunctionWithParams('detchBluetoothStatusListenerAction', params);
            }
        }
    }, {
        key: 'addScanningDeviceListListener',
        value: function addScanningDeviceListListener(bleDeviceList) {
            var event = 'BleDeviceListChanged';
            var params = {
                eventName: event
            };
            if (!this.deviceListeners || this.deviceListeners.size === 0) {
                document.addEventListener(event, this.onContainerBleListChangeEvent, false);
            }
            if (!this.deviceListeners.has(bleDeviceList)) {
                this.deviceListeners.add(bleDeviceList);
            }
            return this.generatePromiseByFunctionWithParams('attachBleDeviceListChangedListenerAction', params);
        }
    }, {
        key: 'removeScanningDeviceListListener',
        value: function removeScanningDeviceListListener() {
            var event = 'BleDeviceListChanged';
            var params = {
                eventName: event
            };
            document.removeEventListener(event, this.onContainerBleListChangeEvent, false);
            this.deviceListeners.clear();
            return this.generatePromiseByFunctionWithParams('detchBleDeviceListChangedListenerAction', params);
        }
        // notify监听维护

    }, {
        key: 'attachListenerWithParams',
        value: function attachListenerWithParams(eventName, listener, func, param) {
            if (typeof listener === 'function') {
                var eventListeners = this.notifyListenersMap.get(eventName);
                if (!eventListeners || eventListeners.size === 0) {
                    // 该eventName初次注册事件监听
                    document.addEventListener(eventName, this.onContainerNotifyEvent, false);
                    window.console.info(eventName + ' first addEventListener');
                    eventListeners = new Set();
                    eventListeners.add(listener);
                    window.console.info(eventName + ' first add , size= ' + eventListeners.size);
                    this.notifyListenersMap.set(eventName, eventListeners);
                } else {
                    window.console.info(eventName + ' befor add, size= ' + eventListeners.size);
                    eventListeners.add(listener);
                    window.console.info(eventName + ' after added, size= ' + eventListeners.size);
                }
                return this.generatePromiseByFunctionWithParams(func, param);
            } else {
                return Promise.reject(new ResultInt('000001', '\u6DFB\u52A0' + eventName + '\u76D1\u542C\u5668\u5931\u8D25,\u76D1\u542C\u4E0D\u662F\u51FD\u6570'));
            }
        }
    }]);

    return UpBle;
}(NebulaModuleBase);